import React from 'react';
import { Download, Sparkles } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { ReportField, StatTiles, STAT_TYPES } from './ReportField';

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

export const PdfButton = ({ url, testid, label = 'Download PDF' }) => (
  <Button variant="outline" size="sm" className="gap-1.5" onClick={() => window.open(url, '_blank')} data-testid={testid}>
    <Download className="h-3.5 w-3.5" /> {label}
  </Button>
);

const ReportSection = ({ section, Icon = Sparkles }) => {
  const stats = section.fields.filter((f) => STAT_TYPES.includes(f.type));
  const rest = section.fields.filter((f) => !STAT_TYPES.includes(f.type));
  return (
    <Card data-testid={`report-section-${section.key}`}>
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <Icon className="h-4 w-4 text-primary" /> {section.title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {stats.length > 0 && <StatTiles fields={stats} />}
        {rest.map((f) => <ReportField key={f.key} field={f} />)}
      </CardContent>
    </Card>
  );
};

// Renders the server-built report view: same groups, sections and fields as the PDF
export const ReportBlocks = ({ view, icons = {}, testid }) => (
  <div className="space-y-8" data-testid={testid}>
    {(view || []).map((g) => (
      <section key={g.title} className="space-y-3" data-testid={`report-group-${slug(g.title)}`}>
        <h3 className="text-[11px] font-bold uppercase tracking-[0.16em] text-primary">{g.title}</h3>
        <div className="space-y-4">
          {g.sections.map((s) => <ReportSection key={s.key} section={s} Icon={icons[s.key]} />)}
        </div>
      </section>
    ))}
  </div>
);

export default ReportBlocks;
